<ct-lib-modal
  [closeable]="!isUpdating() && paymentCheckout()?.loading() !== true"
  #modal
  (onClose)="backToSelection()"
  [label]="modalTitleKey() | transloco"
  [hideFooter]="isPaymentStep() && paymentCheckout()?.loading() === true"
  [footer]="baseBookingModalFooter"
>
  <div class="base-booking-modal" [class.is-busy]="isUpdating()">
    @if (isPaymentMethodStep()) {
      <app-payment-method-choice
        #paymentMethodChoice
        [busy]="bookingInProgress()"
      />
    } @else if (!isPaymentStep()) {
      @if (scheduledBasicChange(); as scheduled) {
        <ct-lib-info-banner type="info" class="schedule-banner">
          <div class="schedule-banner-content">
            <p
              [innerHTML]="
                'company-tool.snippets.base-booking-modal.scheduled-change'
                  | transloco
                    : {
                        date: scheduled.changeAt | date: 'longDate',
                        plan: scheduled.toPlanName || '—',
                      }
              "
            ></p>
            @if (canCancelSchedule()) {
              <app-button
                variant="white-grey"
                [loading]="cancelScheduleBusy()"
                [disabled]="isUpdating()"
                (click)="openCancelScheduleConfirm()"
              >
                {{
                  'company-tool.snippets.base-booking-modal.cancel-schedule'
                    | transloco
                }}
              </app-button>
            }
          </div>
        </ct-lib-info-banner>
      }

      <ct-lib-segmented-control
        class="billing-interval-control mb-3"
        [autowidth]="false"
        [items]="billingIntervalOptions()"
        [selectedValue]="billingInterval()"
        (valueChange)="setBillingInterval($event)"
      ></ct-lib-segmented-control>

      <app-base-plan-selector
        [products]="products()"
        [loaded]="productsLoaded()"
        [billingInterval]="billingInterval()"
        [disabled]="isUpdating()"
        [currentPriceId]="currentBasePriceId()"
        [(selectedPriceId)]="selectedPriceId"
      />

      @if (isUpdating()) {
        <div class="booking-overlay" aria-busy="true" aria-live="polite">
          <ct-lib-spinner [size]="40"></ct-lib-spinner>
          <p>
            {{
              'company-tool.snippets.base-booking-modal.updating' | transloco
            }}
          </p>
        </div>
      }
    } @else {
      <app-payment-checkout
        (paymentCompleted)="onPaymentCompletedFunction()()"
        (paymentFailed)="onPaymentFailed()"
      ></app-payment-checkout>
    }
  </div>
</ct-lib-modal>

<ng-template #baseBookingModalFooter>
  @if (isPaymentStep()) {
    <app-button variant="white-grey" (click)="backToSelection()">
      {{ 'company-tool.snippets.base-booking-modal.back' | transloco }}
    </app-button>
  } @else if (isPaymentMethodStep()) {
    <app-button variant="white-grey" (click)="backToSelection()">
      {{ 'company-tool.snippets.payment-method-choice.back' | transloco }}
    </app-button>
    <app-button
      [loading]="bookingInProgress()"
      [disabled]="bookingInProgress()"
      (click)="confirmPaymentMethod()"
    >
      {{ 'company-tool.snippets.payment-method-choice.continue' | transloco }}
    </app-button>
  } @else {
    <app-button variant="white-grey" (click)="close()">
      {{ 'company-tool.snippets.base-booking-modal.cancel' | transloco }}
    </app-button>
    <app-button
      variant="primary"
      [disabled]="!selectedPriceId() || isSelectedCurrentPlan() || isUpdating()"
      [loading]="isUpdating()"
      (click)="confirmSelection()"
    >
      {{ confirmLabelKey() | transloco }}
    </app-button>
  }
</ng-template>

<ct-lib-confirm-modal
  #downgradeConfirmModal
  [disableConfirmButton]="isUpdating()"
  (onConfirm)="confirmDowngrade()"
  [label]="
    'company-tool.snippets.base-booking-modal.downgrade-confirm.title'
      | transloco
  "
>
  {{
    'company-tool.snippets.base-booking-modal.downgrade-confirm.text'
      | transloco
        : {
            date: downgradeEffectiveDate() | date: 'longDate',
            plan: selectedProduct()?.product?.name,
          }
  }}
</ct-lib-confirm-modal>

<ct-lib-confirm-modal
  #cancelScheduleConfirmModal
  [disableConfirmButton]="cancelScheduleBusy()"
  (onConfirm)="cancelScheduledChange()"
  [label]="
    'company-tool.snippets.base-booking-modal.cancel-schedule-confirm.title'
      | transloco
  "
>
  {{
    'company-tool.snippets.base-booking-modal.cancel-schedule-confirm.text'
      | transloco
        : {
            date: (scheduledBasicChange()?.changeAt | date: 'longDate') || '—',
          }
  }}
</ct-lib-confirm-modal>

<app-invoice-booking-confirm-modal
  #invoiceConfirm
  (confirmed)="onInvoiceBookingConfirmed()"
></app-invoice-booking-confirm-modal>
